import { render, staticRenderFns } from "./UserSysteamInterests.vue?vue&type=template&id=f46b4778&"
import script from "./UserSysteamInterests.vue?vue&type=script&lang=js&"
export * from "./UserSysteamInterests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports